<footer class="w-full shrink-0"
	style="background-image: url('/images/marble_texture_dark.png'); background-size: cover; background-position: center; height: 20px;">
	<div class="mx-auto flex h-full max-w-none items-center justify-between px-4" style="font-family: var(--font-family-ui); font-size: 0.6rem; color: var(--color-sandstone); opacity: 0.7;">
		<span ro-i18n eikey="footer.copyright" [args]="{ year: today.getFullYear() }"></span>
		<span ro-i18n eikey="versions.version" [args]="{ version: versionLabel }"></span>
	</div>
</footer>
